import { Component, Inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-Snackbar',
    templateUrl: './Snackbar.component.html',
    styleUrls: ['./Snackbar.component.scss'],
    providers: [],
    standalone: false
})
export class SnackbarComponent {
	titleText = 'Errors were detected while saving! Correct the following errors and try again';
	dataMessageErr: any;

	constructor(public sbRef: MatSnackBarRef<SnackbarComponent>, @Inject(MAT_SNACK_BAR_DATA) public data: any) {
		this.dataMessageErr = data.error;
	}

	cerrarDialogo(): void {
		this.sbRef.dismiss();
	}
}
